const brandclub_colors = {
  black: '#000',
  blue: '#5572b7',
  blueWhite: '#f6f8fa',
  blueWhiteBorder: '#ebeef1',
  hoverStateColor: '#ebeef1',
  darkBlue: '#181d56',
  darkBlue1: 'rgba(24, 29, 86, 0.1)',
  darkBlue2: 'rgba(24, 29, 86, 0.2)',
  darkBlue3: 'rgba(24, 29, 86, 0.3)',
  darkBlue5: 'rgba(24, 29, 86, 0.5)',
  darkBlue6: 'rgba(24, 29, 86, 0.6)',
  darkBlue9: 'rgba(24, 29, 86, 0.9)',
  grayLight: '#e8e8ed',
  gray: '#7e8fa8',
  grayCFD7DF5C: '#cfd7df5c',
  grayF3F4F5: '#f3f4f5',
  grayDisabled: '#afb0b1',
  gray2: 'rgba(126, 143, 168, 0.2)',
  gray3: 'rgba(126, 143, 168, 0.3)',
  gray5: 'rgba(126, 143, 168, 0.5)',
  grayBorder: '#bec7d3',
  lightGreenECF9F6: '#ecf9f6',
  lightGreen: '#9ee0d0',
  lightGreenLogo: '#a2d9cd',
  lightGreenLogo2: 'rgba(162, 217, 205, 0.2)',
  lightGreenLogo3: 'rgba(162, 217, 205, 0.3)',
  lightGreenLogo5: 'rgba(162, 217, 205, 0.5)',
  lightGreenLogo8: 'rgba(162, 217, 205, 0.8)',
  lightGreenLogo9: '#9ee0d033',
  green: '#71c285',
  green2: '#E2F3EF',
  green3: 'rgba(113, 194, 133, 0.3)',
  greenGray: '#f8f9fa',
  redBright: '#f44a36',
  error: '#ff534a',
  white: '#fff',
  greyBlackGround: '#f7f8f9',
  lightGray: '#dcdddc',
  lightGray_40: 'rgba(220, 221, 220, 0.5)',
  magenta_A22272: 'rgb(162, 34, 114)',
  magenta_A22272_30: 'rgba(162, 34, 114, 0.3)',
  orange_EC792E: 'rgb(236, 121, 46)',
  orange_EC792E_30: 'rgba(236, 121, 46, 0.3)',
  teal_16949B: 'rgb(22, 148, 155)',
  teal_16949B_20: 'rgba(22, 148, 155, 0.2)',
  // chart
  mainSeriesColor: '#181d56',
  mainSeriesColor6: 'rgba(24, 29, 86, 0.6)',
  comparisonSeriesColor: '#add7cd',
  mainSeriesAreaFill: 'rgba(70, 168, 246, 0)',
  comparisonSeriesAreaFill: 'rgba(5, 40, 73, 0)',
  // use following naming convention: colorName_hexcode_opacityPercent
  darkBlue_052849: '#052849', // portal
  darkBlue_181d56: '#181d56', // landing pages
  darkBlue_181d56_10: 'rgba(24, 29, 86, 0.1)',
} as const;

export default brandclub_colors;
